webpackJsonp([136941205615425],{

/***/ 1894:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"OrgLabUpdateResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":"Whether the given credentials verified successfully. Null if this integration type does not support credential verification.","isDeprecated":false,"name":"authenticated","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"args":[],"deprecationReason":null,"description":"Summary of the credential check result. Null if this integration type does not support credential verification.","isDeprecated":false,"name":"message","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"orgLab","type":{"kind":"OBJECT","name":"OrgLab","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-org-lab-update-result-360e496f4ba43194761e.js